"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const node_1 = require("./node");
const index_1 = require("../treeview/index");
const logic_1 = require("./logic");
const keautils_1 = require("keautils");
const HOC_1 = require("../HOC");
class JsonViewComponentControlled extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.valueSelector = (props) => props.value;
        this.onPropClickSelector = (props) => props.onPropClick;
        this.treeSelector = keautils_1.createSelector(this.valueSelector, value => logic_1.valueToJsonTreeView(value));
        this.rendererSelector = keautils_1.createSelector(this.onPropClickSelector, onPropClick => (value, path) => {
            const key = path.length == 0 ? "" : path[path.length - 1];
            return React.createElement(node_1.JsonNodeComponent, { key: key, propname: key, value: value, onClick: onPropClick && (() => onPropClick(path.slice(1))) });
        });
    }
    render() {
        return React.createElement(index_1.TreeComponent, { onStateChange: this.props.onStateChanged, state: this.props.state, valueRenderer: this.rendererSelector(this.props), value: this.treeSelector(this.props) });
    }
}
exports.initialStateTree = {
    collapsed: []
};
/**Dibuja un objecto de javascript en forma de arbol */
exports.Json = HOC_1.makeUncontrolled("state", "onStateChanged", exports.initialStateTree)(JsonViewComponentControlled);



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/jsonview/component.js
// module id = 2236
// module chunks = 0